import { Reducer } from 'redux'
import { ActionTypes, EARN_ACTIONS } from './types'

export type StateFlippers = {
  isEarnEnabled: boolean
}

export type State = StateFlippers

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const initialState: any = {}

export const earn: Reducer<State, ActionTypes> = (state = initialState, action) => {
  switch (action.type) {
    case EARN_ACTIONS.SET_FLIPPERS: {
      const flippers: Partial<StateFlippers> = {}

      if (state && action.flippers.size > 0) {
        action.flippers.forEach((value, key) => {
          flippers[key] = value
        })
      }

      return {
        ...state,
        ...flippers,
      }
    }
    default:
      return state
  }
}
